import type { ResponseType } from '@/types/common';
import type { IssueFieldVersion } from '@/types/issue';
import httpUtil from '@/utils/http';
export * from './project';

const request = httpUtil.mfd.request;
const prefix = 'api/v1/project';

export const issueVersionsApi = {
  /**
   * @description 获取项目下所有版本
   */
  getList(params?: { project: number | number[] }): ResponseType<IssueFieldVersion[]> {
    return request({
      url: prefix + '/versions',
      method: 'GET',
      params,
    });
  },

  /**
   * @description 获取项目下所有版本(带分页参数)
   */
  getListWithPagination(params?: {
    project: number | number[];
    pageIndex?: number;
    pageSize?: number;
  }): ResponseType<IssueFieldVersion[]> {
    return request({
      url: prefix + '/versionsWithPagination',
      method: 'GET',
      params,
    });
  },

  /**
   * @description 创建问题版本
   */
  create(data: {
    project: number;
    vname: string;
    description: string;
    released: boolean;
    startDate: string;
    releaseDate: string;
    demandID?: number;
  }): ResponseType {
    return request({
      url: prefix + '/version',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 根据飞书次版本及需求选择创建版本
   */
  createVersionByFeishu(data: {
    project: number;
    vname: string;
    description: string;
    released: boolean;
    startDate: string;
    releaseDate: string;
    demandID?: number;
    validationType?: number; // 验证类型 1=在研阶段 2=二供物料 3=物料变更整机验证 4=非自研整机验证
    materialName?: string; // 物料名称(验证类型为2/3时必填,自由填写)
  }): ResponseType {
    return request({
      url: prefix + '/createVersionByFeishu',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取物料候选列表(版本创建「物料名称」输入提示)
   * @param validationType 验证类型 2=二供物料 3=物料变更,传入时只返回对应 list
   */
  getMaterialOptions(validationType?: number): ResponseType<string[]> {
    return request({
      url: prefix + '/materialOptions',
      method: 'GET',
      params: { validationType },
    });
  },

  /**
   * @description 更新版本
   */
  update(
    id: number,
    data: {
      vname: string;
      description: string;
      released: boolean;
      startDate: string;
      releaseDate: string;
      validationType?: number; // 验证类型 1=在研阶段 2=二供物料 3=物料变更(整机测试,编辑时可改)
      materialName?: string; // 物料名称(验证类型2/3时必填)
    },
  ): ResponseType {
    return request({
      url: prefix + '/version/' + id,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除版本
   */
  del(id: number): ResponseType {
    return request({
      url: prefix + '/version/' + id,
      method: 'DELETE',
    });
  },

  /**
   * @description 获取即将延期版本数量
   */

  getNearDelayCount(data?: { projects: number[] }): ResponseType {
    return request({
      url: prefix + '/version/nearDelayCount',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 同步对应版本的飞书需求
   */
  syncFeishuDemand(data: { versionId: number }): ResponseType {
    return request({
      url: prefix + `/syncFeishuDemand`,
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新飞书提测信息-第n次提测 && 更新飞书提测链接
   */
  updateFeishuTestInfo(data: { versionId: number; count: number; link: string; [key: string]: any }): ResponseType {
    return request({
      url: prefix + '/updateFeishuTestInfo',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新飞书提测打回信息
   */
  updateFeishuTestRejectInfo(data: { versionId: number; count: number; [key: string]: any }): ResponseType {
    return request({
      url: prefix + '/updateFeishuTestRejectInfo',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新飞书提测完成信息
   */
  updateFeishuTestConclusion(data: { versionId: number; pass: boolean; link: string }): ResponseType {
    return request({
      url: prefix + '/updateFeishuTestConclusion',
      method: 'POST',
      data,
    });
  },
};
